export default "__VITE_ASSET__DxbdCQyT__"